import React from 'react';
import classNames from 'classnames';

const Stamp = ({ isTile, status, tileType, time, duration, liveLabel }) => {
    const stampClass = classNames('media-duration', {
        'media-duration--item': isTile, // gotta pass in the parent doing the embedding because of this class, not cool
        'media-duration--live': status === 'live'
    });

    let stampContent = null;
    if (tileType === 'video') {
        stampContent = duration;
    } else {
        switch (status) {
            case 'live':
                stampContent = liveLabel;
                break;
            case 'upcoming':
                // #TODO: get design for upcoming events that don't air the same day
                stampContent = time;
                break;
            case 'replay':
                stampContent = duration;
                break;
            default:
                stampContent = duration || null;
        }
    }

    if (stampContent) {
        return (<div className={stampClass}>{stampContent}</div>);
    }
    return null;
};

Stamp.propTypes = {
    isTile: React.PropTypes.bool,
    tileType: React.PropTypes.string,
    time: React.PropTypes.string,
    duration: React.PropTypes.string,
    status: React.PropTypes.string,
    liveLabel: React.PropTypes.string
};

export default Stamp;



// WEBPACK FOOTER //
// ./app/common/Stamp.js